import baseUrl from '@/api/baseUrl'
export default baseUrl+'/sc'